// extracted by mini-css-extract-plugin
export default {"versions":"bv_gH","newsletterSignup":"bv_gJ","announcement":"bv_gK"};